const modelBasedPatterns = [
  'Collection',
  'Canvas',
  'Cinemagraph',
  'Carousel',
  'OEM',
  'Video'
];

const dealershipBrandPatterns = [
  'Spot',
  'Drone',
  'Employee',
  'Buying Program',
  'Corp',
  'Corporate',
  'Hiring',
  'University',
  'Industry',
  'Store',
  '_CR ',
  'Service Generic'
];

const offersPatterns = [
  'Special',
  'Specials',
  'Lease',
  'Leasing',
  'Incentive',
  'INCENTIVE',
  'DAA',
  'Dynamic',
  '_Credit_',
  'Service Incentive'
];

const videoViewPatterns = [
  '360',
  'Drone',
  'OEM',
  'Spot',
  'Video',
  'Cinemagraph'
];
const conversionsPatterns = [
  'Canvas',
  'Carousel',
  'Cinemagraph',
  'Collection',
  'Still',
  'Video'
];
const productCatalogSalesPatterns = ['Carousel', 'Still'];

export const adPatterns = {
  VIDEO_VIEWS: videoViewPatterns,
  LINK_CLICKS: conversionsPatterns,
  CONVERSIONS: conversionsPatterns,
  PRODUCT_CATALOG_SALES: productCatalogSalesPatterns,
  MODEL_BASED: modelBasedPatterns,
  DEALERSHIP_BRANDING: dealershipBrandPatterns,
  OFFERS: offersPatterns
};

export const restructureCampaign = (campaignMonth) => {
  const newCampaignMonth = {
    MODEL_BASED: [], // Model tab
    DEALERSHIP_BRANDING: [], // Brand tab
    OFFERS: [] // Offer tab
    // to do: add Other category
  };

  const flattenedCampaignMonth = flattenObjectWithArraysToArray(campaignMonth);
  const flattenedCampaignMonthCopy = [...flattenedCampaignMonth];

  flattenedCampaignMonth.forEach((ad, index) => {
    const { name, ad_original_name: adOriginalName, ad_name: adName } =
      ad || {};
    let nameLowerCase = '';
    if (adName) {
      nameLowerCase = adName.toLowerCase();
    } else {
      nameLowerCase = name ? name.toLowerCase() : adOriginalName.toLowerCase();
    }
    adPatterns.OFFERS.forEach((pattern) => {
      if (
        nameLowerCase.indexOf(pattern.toLowerCase()) !== -1 &&
        flattenedCampaignMonthCopy[index].ad_name
      ) {
        newCampaignMonth.OFFERS.push(ad);
        flattenedCampaignMonthCopy[index] = {};
      }
    });
  });

  flattenedCampaignMonth.forEach((ad, index) => {
    const { name, ad_original_name: adOriginalName, ad_name: adName } =
      ad || {};
    let nameLowerCase = '';
    if (adName) {
      nameLowerCase = adName.toLowerCase();
    } else {
      nameLowerCase = name ? name.toLowerCase() : adOriginalName.toLowerCase();
    }
    adPatterns.DEALERSHIP_BRANDING.forEach((pattern) => {
      if (
        nameLowerCase.indexOf(pattern.toLowerCase()) !== -1 &&
        flattenedCampaignMonthCopy[index].ad_name
      ) {
        if (
          nameLowerCase.indexOf('oem') !== -1 &&
          nameLowerCase.indexOf('spot') !== -1
        ) {
          newCampaignMonth.MODEL_BASED.push(ad);
        } else {
          newCampaignMonth.DEALERSHIP_BRANDING.push(ad);
        }
        flattenedCampaignMonthCopy[index] = {};
      }
    });
  });

  newCampaignMonth.MODEL_BASED = flattenedCampaignMonthCopy.filter((ad) => {
    return ad.ad_id;
  });

  const newQcProcess = restructureAdQc(newCampaignMonth);
  const newGeneralQcProgess = getGeneralQcProgess(newQcProcess);

  const returnCampaignObject = {
    campaignMonth: newCampaignMonth,
    qcProcess: newQcProcess,
    generalQcProgress: newGeneralQcProgess
  };

  return returnCampaignObject;
};

const flattenObjectWithArraysToArray = (campaignMonth) => {
  let flattenedArray = [];
  const oldStructureKeys = Object.keys(campaignMonth);
  oldStructureKeys.forEach((key) => {
    flattenedArray = flattenedArray.concat(campaignMonth[key]);
  });
  return flattenedArray;
};

export const restructureAdQc = (campaignMonth) => {
  const campaignKeys = Object.keys(campaignMonth);
  const newQcProgress = {};
  campaignKeys.forEach((key) => {
    newQcProgress[key] = {
      totalAds: 0,
      totalQC: 0
    };
  });
  campaignKeys.forEach((key) => {
    newQcProgress[key] = {
      totalAds: campaignMonth[key].length,
      totalQC: 0
    };
    campaignMonth[key].forEach((ad) => {
      const { adQc } = ad;
      const { qc2 } = adQc || {};
      if (adQc !== null && qc2 && qc2 === 'true') {
        newQcProgress[key].totalQC += 1;
      }
    });
  });
  return newQcProgress;
};

export const getGeneralQcProgess = (qcAdsProgress) => {
  let totalAds = 0;
  let totalQC = 0;
  Object.keys(qcAdsProgress).forEach((key) => {
    totalAds = totalAds + qcAdsProgress[key].totalAds;
    totalQC = totalQC + qcAdsProgress[key].totalQC;
  });
  const generalQCProgress = (totalQC * 100) / totalAds;
  return generalQCProgress;
};



// WEBPACK FOOTER //
// ./src/utils/campaignRestructuring.js